export const PARTY_WISE_ITEM_SALE_REPORT_GO_BUTTON_API = 'PARTY_WISE_ITEM_SALE_REPORT_GO_BUTTON_API'
export const PARTY_WISE_ITEM_SALE_REPORT_GO_BUTTON_API_SUCCESS = 'PARTY_WISE_ITEM_SALE_REPORT_GO_BUTTON_API_SUCCESS'


export const PARTY_WISE_ITEM_SALE_REPORT_API_ERROR_ACTION = 'PARTY_WISE_ITEM_SALE_REPORT_API_ERROR_ACTION'